import { useMemo } from 'react';
import { tv } from 'tailwind-variants';

export const CruiseButton = ({
	onClick,
	isDriving,
	disabled,
}: {
	onClick: () => void;
	isDriving: boolean;
	disabled?: boolean;
}) => {
	const ButtonVariants = tv({
		base: 'w-full h-full rounded-3xl text-5xl font-bold transition disabled:bg-gray-800 shadow-xl',
		variants: {
			isDriving: {
				true: 'bg-red-600 hover:bg-red-700 active:bg-red-700',
				false: 'bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-700',
			},
		},
	});

	const content = useMemo(() => {
		if (disabled) {
			return '주차 중 주행 불가';
		}
		return isDriving ? '주행 종료' : '주행 시작';
	}, [isDriving, disabled]);

	return (
		<button
			onClick={onClick}
			className={ButtonVariants({ isDriving })}
			disabled={disabled}
		>
			{content}
		</button>
	);
};
